import { THEME } from "@/3514/theme"
import { buildCssClassName } from "@/3514/utils"

import { ECopyButtonVariant as EVariant } from "./copy-button.types"

const iconColorsMap: { [V in EVariant]: (isActionAffected: boolean) => string } = {
    [EVariant.Blue]: (isActionAffected: boolean): string =>
        isActionAffected ? THEME.COLORS.blue[100] : THEME.COLORS.blue[300],
    [EVariant.Gray]: (isActionAffected: boolean): string =>
        isActionAffected ? THEME.COLORS.blue[100] : THEME.COLORS.gray[300]
}

const _baseClasses: string = "px-[6px] py-[6px] rounded-[5px]"

const buttonColorsMap: { [V in EVariant]: (isActionAffected: boolean) => string } = {
    [EVariant.Blue]: (isActionAffected: boolean): string =>
        buildCssClassName(_baseClasses, isActionAffected ? "bg-blue-500" : "bg-white"),
    [EVariant.Gray]: (isActionAffected: boolean): string =>
        buildCssClassName(_baseClasses, isActionAffected ? "bg-gray-500" : "bg-transparent")
}

const config = { iconColorsMap, buttonColorsMap }

export { config as copyButtonConfig }
